import React from "react";
import { FaFacebook, FaSpotify, FaYoutube } from "react-icons/fa";
import "./SocialsStyles.scss";
const Socials = () => {
  return (
    <div className='socials'>
      <a href='https://www.facebook.com/lepavillondemusique/' target='_blank'>
        <FaFacebook className='socials__icon' size={44} />
      </a>
      <a href='https://open.spotify.com/artist/5EjxLRUIqH1ufxMxMzB7ER?si=W2ALOJn2SVe2g6Oco1JYwQ' target='_blank'>
        <FaSpotify className='socials__icon' size={44} />
      </a>
      <a href='https://www.youtube.com/watch?v=ExWdBAE4U70&list=RDExWdBAE4U70&start_radio=1' target='_blank'>
        <FaYoutube className='socials__icon' size={44} />
      </a>
    </div>
  );
};

export default Socials;
